document.addEventListener('DOMContentLoaded', function() {
  var quickFilters = document.querySelectorAll('.quick-filter');

  quickFilters.forEach(function(quickFilter) {
    quickFilter.addEventListener('click', function() {
      var quickName = this.getAttribute('name').toLowerCase();
      var quickValue = this.getAttribute('value');
      console.log(quickName + " " + quickValue);

      var inputChecking = document.querySelectorAll('details.js-filter input[type="checkbox"][name="' + quickName + '"][value="' + quickValue + '"]');
      
      // Check if an input element was found
      if (inputChecking.length > 0) {
       var parentElement = inputChecking[0].parentNode;
        if (parentElement && typeof parentElement.click === 'function') {
          parentElement.click();
           parentElement.classList.add('active-class');
        }

      }
    });
  });
});
